"use client";
import { FC, PropsWithChildren, useContext, useEffect } from "react";
import { CscInternalSearchContext } from "./CscInternalSearchContextBlock";
import { useSearchResults } from "@/components/InternalSearch";
import { BuilderProps } from "@/types";
import { GetSearchResultProduct } from "@/types/General";

type InternalSearchBannerBlockProps = {
  variant: "swdc" | "support";
  builderContext?: BuilderProps["builderContext"];
};

export const InternalSearchBannerBlock: FC<
  PropsWithChildren<InternalSearchBannerBlockProps>
> = ({ children, builderContext, variant = "swdc" }) => {
  const { bannerInfo } = useContext(CscInternalSearchContext);
  const { bannerProduct } = useSearchResults();

  const banner = variant === "support" ? bannerInfo : bannerProduct;

  useEffect(() => {
    if (!builderContext?.rootSetState) {
      return;
    }

    const shouldUpdate =
      banner?.shortName !==
      (
        builderContext.rootState
          ?.internalSearchBannerInfo as GetSearchResultProduct
      )?.shortName;

    if (shouldUpdate) {
      builderContext.rootSetState({
        ...builderContext.rootState,
        internalSearchBannerInfo: banner,
      });
    }
  }, [banner, builderContext]);

  return <>{children}</>;
};
